import React from 'react';
import { GroupEntity } from '../../../types';
import { Option, Select } from '../../../../../components';
import style from '../group.module.scss';
import { EntitiesCRD } from '../hooks';
import { Entity } from './Entity';
import { Empty } from './Empty';

type Props = {
	isAdding: boolean;
	entitiesCRD: EntitiesCRD;
	groupEntities: GroupEntity[];
	entitiesOptions: Option[];
};

export function Entities(props: Props) {
	const { isAdding, groupEntities, entitiesOptions } = props;
	const { actions, list, deleteList } = props.entitiesCRD;
	const entities = groupEntities.concat(
		entitiesObjMapper(list, entitiesOptions),
	);

	let canshow = entities.length <= 0 ? true : false;
	let entityValuesLength = 0
	let deleteEntityValuesLength = 0
	entities.forEach((k) => { entityValuesLength += Object.keys(k.values).length })
	for (const key in deleteList)
		{
		const item = deleteList[key];
		deleteEntityValuesLength += item.length
		   
		}

	if (entityValuesLength === deleteEntityValuesLength) {
		canshow = true
	}
	if (canshow && !isAdding) {
		return <Empty type="entities" />;
	}	
	return (
		<div className={style.entities}>
			{isAdding && (
			<Select
			options={entitiesOptions}
					onSelect={(value) => {
						const [entity, entityValue] = value.split(':');
						var canAdd = true;
						entities.forEach((el) => {
							if (el?.id == entity && Object.keys(el?.values).includes(entityValue)) {
								canAdd = false;
							}	
							if (entity in deleteList && deleteList[entity].indexOf(entityValue) !== -1) {
								canAdd = true
							}
						})
						if (canAdd) {
							actions.addItem(entity, entityValue)
						}
					}}
			placeholder="Select entities"
			value=""
		/>
			)}
			{entities.map((el) => {
	  return Object.keys(el?.values).map((m) => {
		let canHide = false;
		if (deleteList[el?.id]?.length > 0 && deleteList[el?.id].includes(m)) {
			canHide = true	
		}
		if (!canHide) {
				return (
					<Entity
						deleteEntity={(k,v) => {
							actions.deleteItem(k,v);
						}}
						key={m}
						entity={el}
						value={el.values[m]}
						keyValue={m}
					/>
				);
			}
	})
			})}
		</div>
	);
}

function entitiesObjMapper(obj: Record<string, string[]>, options: Option[]) {
	const entities: GroupEntity[] = [];

	Object.entries(obj).forEach(([key, value]) => {
		const entity = options.find((option) => option.value === key);
		if (entity?.options) {
			 entity.options.find((option) => {
					value.forEach((v) => {
						if (v === option.value) {
							entities.push({
								id: key,
								name: entity.label,
								values: {
									[option.value]: option.label,
								},
							});
						}
					})
				}
			);
		}
	});
	return entities;
}
